"use strict";

angular.module("core").component("imageUpload", {
    templateUrl: require("./image-upload.component.html"),
    controller: function($scope, Language) {
        Language.initializeScope($scope, null, "locale");
    },
    controllerAs: "imageUploadCtrl",
    bindings: {
        name: "@",
        form: "=",
        fileTypesAllowed: "@",
        maxFileSize: "<",
        imagePath: "<?",
        helpText: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/image-upload/image-upload.component.js
// module id = 569
// module chunks = 0